import ConnectModal from '../components/ConnectModal';
import ActionConfirm from '../components/ActionConfirm';
import Navbar from '../components/Navbar';
import { Button, Container, Divider, Dropdown, Menu } from '../components';
import { MODE } from '../constants';
import { joinPath } from '../common';

import { NavLink, Route } from 'react-router-dom';
import React, { Fragment } from 'react';
import { pick } from 'lodash';

/*
export const PageBreadcrumb = ({ sections }) => (
  <Breadcrumb
    divider={<Icon name="right chevron" />}
    sections={[
      { key: 'home', content: 'Home', as: NavLink, to: '/' },
      ...sections.map(
        section =>
          typeof section === 'object' && 'to' in section
            ? { as: NavLink, ...section }
            : section,
      ),
    ]}
  />
);
*/

import logo from '../logo.png';

export const Layout = ({ app, route, menu, children }) => {
  const navbarLogoItem = (
    <Navbar.Item
      as={NavLink}
      exact={true}
      to={route.baseUrl}
      activeClassName=""
    >
      <img src={logo} alt="" /> &nbsp;Nosturi
    </Navbar.Item>
  );

  const navbarPageItems = app.pages.map(({ slug, title }) => (
    <Navbar.Item
      key={slug}
      as={NavLink}
      exact={slug === ''}
      to={joinPath(route.baseUrl, slug)}
      content={title}
    />
  ));

  const navbarTerminalsDropdown = (
    <Dropdown item text="Terminals">
      <Dropdown.Menu>
        {app.terminals.map(({ slug, title }) => (
          <Dropdown.Item
            key={slug}
            as={NavLink}
            to={joinPath(route.baseUrl, slug)}
            content={title}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  const navbarDisplaysDropdown = (
    <Dropdown item text="Displays">
      <Dropdown.Menu>
        {app.displays.map(({ slug, title }) => (
          <Dropdown.Item
            key={slug}
            as={NavLink}
            to={joinPath(route.baseUrl, slug)}
            content={title}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  const modeTexts = {
    [MODE.OFFLINE]: 'Offline',
    [MODE.CONNECT]: 'Connected',
    [MODE.SHARE]: 'Sharing',
  };

  const modeActions = {
    [MODE.OFFLINE]: 'Connect',
    [MODE.CONNECT]: 'Disconnect',
    [MODE.SHARE]: 'Stop',
  };

  const onConnect = ({ address, pin }) => {
    route.history.push('/connect/xyz');
  };

  const onDisconnectConfirm = () => {
    route.history.push('/');
  };

  /*
  const modeButton = <Button animated circular>
    <Button.Content visible>{}</Button.Content>
    <Button.Content hidden>{modeActions[app.mode]}</Button.Content>
  </Button>;
  */

  const trigger = (
    <Button animated circular>
      <Button.Content visible>{modeTexts[app.mode]}</Button.Content>
      <Button.Content hidden>{modeActions[app.mode]}</Button.Content>
    </Button>
  );

  const modeButton =
    app.mode === MODE.OFFLINE ? (
      <ConnectModal
        id={`connect-modal`}
        trigger={trigger}
        onConnect={onConnect}
      />
    ) : (
      <ActionConfirm
        trigger={trigger}
        header="Do you really want to disconnect?"
        confirmButton={<Button negative>Disconnect</Button>}
        cancelButton={<Button>Cancel</Button>}
        onConfirm={onDisconnectConfirm}
        basic
      />
    );

  return (
    <Fragment>
      <Navbar history={route.history} logoItem={navbarLogoItem} attached>
        {navbarPageItems}
        {navbarTerminalsDropdown}
        {navbarDisplaysDropdown}
        <Navbar.Item position="right">{modeButton}</Navbar.Item>
      </Navbar>
      {menu}
      <Container as="header">{app.messages}</Container>
      <Container as="main">{children}</Container>
      <Container as="footer" textAlign="center">
        <Divider />
        <p>
          <small>
            <strong>&copy; Nosturi 2018</strong>
          </small>
        </p>
      </Container>
    </Fragment>
  );
};

export const SubPagesLayout = ({
  app,
  route,
  //breadcrumbSections = [],
  children,
}) => {
  const menu = (
    <Menu secondary pointing attached>
      {children.map(({ slug, title }) => (
        <Menu.Item
          as={NavLink}
          key={slug}
          content={title}
          exact={!slug.length}
          to={joinPath(route.match.url, slug)}
        />
      ))}
    </Menu>
  );

  return (
    <Layout app={app} route={route} menu={menu}>
      {children.map(({ slug, ...props }) => (
        <Route
          key={slug}
          exact={!slug.length}
          path={joinPath(route.match.url, slug)}
          {...pick(props, 'render', 'component')}
        />
      ))}
    </Layout>
  );
};



// WEBPACK FOOTER //
// ./src/pages/common.js